import React from 'react';
import Link from 'next/link';
import Icon from '@components/common/assets';
import Colors from '@domain/constant/colors';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const Banner4 = () => {
  return (
    <div className={cx('commonBox')}>
      <span className={cx('desc')}>
        역량검사까지 완료하고 JOBDA matching을 통해
        <br />
        기업에서 직접 입사 제안받아보세요!
      </span>

      <Link className={cx('btnMove')} href={RouteUrl.MATCH_INTRODUCE} target="_blank">
        JOBDA matching 자세히 보기
        <Icon name="arrowUpwardLight" width={32} height={32} fill={Colors.C_LIGHT_GREEN_100} />
      </Link>
    </div>
  );
};

export default Banner4;
